<template>
  <div class="personal-loan-interest-rate">
    <div class="form-group row">
      <div
        :class="'col-md-2 form-group ' + (validations !== null && validations.hasOwnProperty('start_amount') ? 'has-error' : '')"
      >
        <label class="required">{{ $t('fields.startAmount') }}</label>
        <input
          type="number"
          class="form-control"
          v-model="interestRate.start_amount"
          :placeholder="$t('fields.startAmount')"
        >
        <span
          class="label-error"
          v-if="validations !== null && validations.hasOwnProperty('start_amount')"
        >
          {{ validations['start_amount'][0] }}
        </span>
      </div>
      <div
        :class="'col-md-2 form-group ' + (validations !== null && validations.hasOwnProperty('end_amount') ? 'has-error' : '')"
      >
        <label class="required">{{ $t('fields.endAmount') }}</label>
        <input
          type="number"
          class="form-control"
          v-model="interestRate.end_amount"
          :placeholder="$t('fields.endAmount')"
        >
        <span
          class="label-error"
          v-if="validations !== null && validations.hasOwnProperty('end_amount')"
        >
          {{ validations['end_amount'][0] }}
        </span>
      </div>
      <div
        :class="'col-md-2 form-group ' + (validations !== null && validations.hasOwnProperty('start') ? 'has-error' : '')"
      >
        <label class="required">{{ $t('fields.startMonth') }}</label>
        <input
          type="number"
          class="form-control"
          v-model="interestRate.start"
          :placeholder="$t('fields.startMonth')"
        >
        <span
          class="label-error"
          v-if="validations !== null && validations.hasOwnProperty('start')"
        >
          {{ validations['start'][0] }}
        </span>
      </div>

      <div
        :class="'col-md-2 form-group ' + (validations !== null && validations.hasOwnProperty('end') ? 'has-error' : '')"
      >
        <label class="required">{{ $t('fields.endMonth') }}</label>
        <input
          type="number"
          class="form-control"
          v-model="interestRate.end"
          :placeholder="$t('fields.endMonth')"
        >
        <span
          class="label-error"
          v-if="validations !== null && validations.hasOwnProperty('end')"
        >
          {{ validations['end'][0] }}
        </span>
      </div>

      <div
        :class="'col-md-4 form-group ' + (validations !== null && validations.hasOwnProperty('percentage') ? 'has-error' : '')"
      >
        <label class="required">{{ $t('fields.percentage') }}</label>
        <input
          type="number"
          class="form-control"
          v-model="interestRate.percentage"
          :placeholder="$t('fields.percentage')"
        >
        <span
          class="label-error"
          v-if="validations !== null && validations.hasOwnProperty('percentage')"
        >
          {{ validations['percentage'][0] }}
        </span>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-md-12">
        <template v-if="editable">
          <button
            @click="onClickUpdate"
            class="btn btn-primary margin-right-5 btn-sm btn-update"
          >
            {{ $t('buttons.save') }}
          </button>
        </template>
        <button
          @click="onClickBack"
          class="btn btn-default btn-sm btn-back"
        >
          {{ $t('buttons.cancel') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PawnInterestRateForm',
  props: {
    editable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      interestRate: {
        percentage: null,
        start: 0,
        end: 0,
        start_amount: null,
        end_amount: null
      },
      id: null,
      validations: null
    }
  },
  computed: {
    api () {
      return `${process.env.VUE_APP_API}/api/v1/interest-rate/pawn`
    }
  },
  methods: {
    onClickBack () {
      this.$router.push({
        name: 'list-pawn-interest-rate'
      })
    },
    onClickUpdate () {
      const self = this
      this.$isLoading(true)
      this.$axios.post(`${this.api}/store`, this.interestRate)
        .then(() => {
          this.$toastr(
            'success',
            self.$t('string.theRecordWasUpdated'),
            self.$t('string.interestRate')
          )
          this.onClickBack()
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.validations = error.response.data.errors
          } else {
            this.onResponseError(error)
          }
        })
        .finally(() => {
          this.$isLoading(false)
        })
    },
    getInterestRate () {
      this.$isLoading(true)
      this.$axios.post(`${this.api}/get-interest-rate`, {
        id: this.$route.params.id
      }).then((response) => {
        if (response.data && response.data.data) {
          this.interestRate = response.data.data
        }
      }).catch((error) => {
        this.onResponseError(error)
      }).finally(() => {
        this.$isLoading(false)
      })
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (!this.editable) {
        $('input').attr('disabled', 'disabled')
      }
      if (this.$route.params.hasOwnProperty('id')) {
        this.getInterestRate()
      }
    })
  }
}
</script>

<style scoped>

</style>
